export const OrderRequestState = {
  CREATED: "CREATED",
  SETTLED: "SETTLED",
  PAID: "PAID",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  UNKNOWN: "UNKNOWN",
  DELETED: "DELETED",
  REFUNDED: "REFUNDED",
  QUEUED: "QUEUED",
};

export const OrderRequestStateFarsi = {
  CREATED: "در انتظار تایید صندوق",
  SETTLED: "در انتظار تایید صندوق",
  PAID: "در انتظار تایید صندوق",
  PENDING: "در انتظار تایید صندوق",
  APPROVED: "تایید شده",
  UNKNOWN: "در انتظار تایید صندوق",
  DELETED: "حذف شده",
  REFUNDED: "ناموفق",
  QUEUED: "در انتظار تایید",
};

export const OrderRequestType = {
  BUY: "BUY",
  SELL: "SELL",
};

export const PurchaseMethod= {
  MANUAL : "مستقیم",
  AUTOMATIC : "خودکار",
}
export const OrderRequestTypeFarsi = {
  BUY: "خرید",
  SELL: "فروش",
};

export const OrderRequestBrokerType = {
  BALOOT: "BALOOT",
  OTHER: "OTHER",
};

export const OrderRequestBrokerTypeFarsi = {
  BALOOT: "بلوط",
  OTHER: "خارج از بلوط",
};

export const OrderRequestPurchaseMethod = {
  AUTOMATIC: "AUTOMATIC",
  MANUAL: "MANUAL",
  UNKNOWN: "UNKNOWN",
};

export const OrderRequestPurchaseMethodFarsi = {
  AUTOMATIC: "خودکار",
  MANUAL: "دستی",
  UNKNOWN: "نامشخص",
};
